import { jsx as _jsx } from "react/jsx-runtime";
var Time = function Time() {
  return /*#__PURE__*/_jsx("svg", {
    width: "21",
    height: "21",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("g", {
      id: "Date",
      children: /*#__PURE__*/_jsx("path", {
        id: "Union",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.6471 10.0152C17.6471 5.87304 14.2893 2.51518 10.1471 2.51518C6.005 2.51518 2.64714 5.87304 2.64714 10.0152C2.64714 14.1573 6.005 17.5152 10.1471 17.5152C14.2893 17.5152 17.6471 14.1573 17.6471 10.0152ZM10.1471 0.848511C15.2097 0.848511 19.3138 4.95257 19.3138 10.0152C19.3138 15.0778 15.2097 19.1818 10.1471 19.1818C5.08452 19.1818 0.980469 15.0778 0.980469 10.0152C0.980469 4.95257 5.08452 0.848511 10.1471 0.848511ZM10.9805 5.01518C10.9805 4.55494 10.6074 4.18184 10.1471 4.18184C9.6869 4.18184 9.3138 4.55494 9.3138 5.01518V10.0152C9.3138 10.3308 9.49214 10.6194 9.77446 10.7605L13.1078 12.4272C13.5194 12.633 14.02 12.4662 14.2258 12.0545C14.4316 11.6429 14.2648 11.1423 13.8531 10.9365L10.9805 9.50015V5.01518Z",
        fill: "#81858C"
      })
    })
  });
};
export default Time;